<template>
  <b-container fluid>
    <FormulateForm
      name="createCampaign"
      @submit="submitHandler"
      #default="{ isLoading, hasErrors }"
      v-model="formValues"
      data-cy="create-campaign-form"
    >
      <b-row>
        <b-col lg="6" offset-lg="3">
          <iq-card>
            <template v-slot:headerTitle>
              <h4 class="card-title">Message parameters</h4>
            </template>
            <template v-slot:body>
              <b-form-row>
                <b-col>
                  <b-form-group label="Campaign Name" label-for="name">
                    <FormulateInput
                      id="name"
                      name="name"
                      type="text"
                      validation="required"
                      input-class="form-control"
                      validation-name="Name"
                      data-cy="name-input"
                    />
                  </b-form-group>
                </b-col>
              </b-form-row>
              <b-form-row>
                <b-col>
                  <b-form-group label="Domain" label-for="domain">
                    <FormulateInput
                      id="domain"
                      name="domain"
                      type="select"
                      validation="required"
                      validation-name="Domain"
                      placeholder="Choose domain"
                      data-cy="domain-select"
                      :options="
                        allowedDomains.map((d) => ({
                          value: d,
                          label: d,
                        }))
                      "
                    />
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label="From email" label-for="fromEmail">
                    <FormulateInput
                      id="fromEmail"
                      name="fromEmail"
                      type="text"
                      validation="required|isFromEmailValid"
                      :validation-rules="{
                        isFromEmailValid: (params) => {
                          return validateFromEmail(params);
                        },
                      }"
                      :validation-messages="{
                        isFromEmailValid: 'Email is not from domain.',
                      }"
                      input-class="form-control"
                      :disabled="!isFromEmailEditable"
                      validation-name="From email"
                    />
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label="Sender Name" label-for="fromName">
                    <FormulateInput
                      id="fromName"
                      name="fromName"
                      type="text"
                      input-class="form-control"
                      data-cy="from-name-input"
                      class="mb-0"
                    />
                    <p><small>pretty name displayed in the inboxes</small></p>
                  </b-form-group>
                </b-col>
              </b-form-row>
              <hr />
              <b-form-row>
                <b-col>
                  <b-form-group label="Subject" label-for="subject">
                    <FormulateInput
                      id="subject"
                      name="subject"
                      type="text"
                      validation="required"
                      validation-name="Subject"
                      input-class="form-control"
                      data-cy="subject-input"
                    />
                  </b-form-group>
                </b-col>
              </b-form-row>
              <!-- <b-form-row>
                <b-col>
                  <b-form-group
                    label="Preview text (optional)"
                    label-for="previewText"
                  >
                    <FormulateInput
                      id="previewText"
                      name="previewText"
                      type="text"
                      input-class="form-control"
                    />
                  </b-form-group>
                </b-col>
              </b-form-row>-->
            </template>
          </iq-card>
        </b-col>
        <b-col lg="6" offset-lg="3">
          <iq-card>
            <template v-slot:headerTitle>
              <h4 class="card-title">Audience</h4>
            </template>
            <template v-slot:body>
              <b-form-row>
                <b-col>
                  <b-form-group label="List" label-for="listId">
                    <FormulateInput
                      id="listId"
                      name="listId"
                      type="select"
                      validation="required"
                      validation-name="List"
                      placeholder="Choose list"
                      data-cy="list-select"
                      :options="
                        lists.map((c) => ({
                          value: c.id,
                          label: c.name,
                        }))
                      "
                    />
                  </b-form-group>
                  <div class="open-detail-label">
                    <router-link v-if="formValues.listId" :to="'/lists/'+formValues.listId+'/edit'" target="_blank">Open list in new tab</router-link>
                  </div>
                </b-col>
              </b-form-row>
            </template>
          </iq-card>
        </b-col>
        <b-col lg="6" offset-lg="3">
          <iq-card>
            <template v-slot:headerTitle>
              <h4 class="card-title">Template</h4>
            </template>
            <template v-slot:body>
              <b-form-row>
                <b-col>
                  <b-form-group label="Template" label-for="templateId">
                    <FormulateInput
                      id="templateId"
                      name="templateId"
                      type="select"
                      validation-name="Template"
                      validation="required"
                      placeholder="Choose template"
                      data-cy="template-select"
                      :options="
                        templates.map((t) => ({
                          value: t.id,
                          label: t.name,
                        }))
                      "
                    />
                  </b-form-group>
                  <div class="open-detail-label">
                    <router-link v-if="formValues.templateId" :to="'/templates/'+formValues.templateId+'/edit'" target="_blank">Open template in new tab</router-link>
                  </div>
                </b-col>
              </b-form-row>
            </template>
          </iq-card>
        </b-col>
        <b-col lg="6" offset-lg="3">
          <iq-card>
            <template v-slot:headerTitle>
              <h4 class="card-title">Targets</h4>
            </template>
            <template v-slot:body>
              <b-form-group label="Product groups" label-for="selectedProductGroupIds">
                <p>Select at least one product group.</p>
                    <FormulateInput
                      id="selectedProductGroupIds"
                      name="selectedProductGroupIds"
                      type="select"
                      multiple
                      validation-name="selectedProductGroupIds"
                      validation="required"
                    >
                    <template #element>
                      <v-select
                      required
                      multiple
                      :closeOnSelect="true"
                      v-model="formValues.selectedProductGroupIds"
                      :reduce="(productGroup) => productGroup.id"
                      label="name"
                      :options="productGroupsOptions"
                    ></v-select>
                    </template>
                    </FormulateInput>
                  </b-form-group>
              <b-form-row>
                <b-col>
                  <b-form-group
                    label="Target deal value"
                    label-for="targetDealValue"
                  >
                    <FormulateInput
                      id="targetDealValue"
                      name="targetDealValue"
                      type="number"
                      step="0.01"
                      data-cy="target-deal-value-input"
                    />
                  </b-form-group>
                </b-col>
              </b-form-row>
            </template>
          </iq-card>
        </b-col>
        <b-col lg="6" offset-lg="3">
          <iq-card>
            <template v-slot:headerTitle>
              <h4 class="card-title">External link</h4>
            </template>
            <template v-slot:body>
              <b-form-row>
                <b-col>
                  <b-form-group label="External link" label-for="externalLink">
                    <FormulateInput
                      id="externalLink"
                      name="externalLink"
                      type="text"
                    />
                  </b-form-group>
                </b-col>
              </b-form-row>
            </template>
          </iq-card>
        </b-col>
        <!-- <b-col lg="6" offset-lg="3">
          <iq-card>
            <template v-slot:headerTitle>
              <h4 class="card-title">UTM parameters</h4>
            </template>
            <template v-slot:body>
              <b-form-row>
                <b-col>
                  <b-form-group
                    label="Preview text (optional)"
                    label-for="exampleInputText1"
                  >
                    <v-select name="user_id" :options="['Name ', 'name']" />
                  </b-form-group>
                </b-col>
              </b-form-row>
              <b-form-row>
                <b-col>
                  <b-form-group
                    label="Preview text (optional)"
                    label-for="exampleInputText1"
                  >
                    <v-select name="user_id" :options="['Name ', 'name']" />
                  </b-form-group>
                </b-col>
              </b-form-row>
            </template>
          </iq-card>
        </b-col>
        <b-col lg="6" offset-lg="3">
          <iq-card>
            <template v-slot:headerTitle>
              <h4 class="card-title">Sending type</h4>
            </template>
            <template v-slot:body>
              <b-form-row>
                <b-col>
                  <b-form-group
                    label="Preview text (optional)"
                    label-for="exampleInputText1"
                  >
                    <v-select name="user_id" :options="['Name ', 'name']" />
                  </b-form-group>
                </b-col>
              </b-form-row>
              <b-form-row>
                <b-col>
                  <b-form-group
                    label="Preview text (optional)"
                    label-for="exampleInputText1"
                  >
                    <v-select name="user_id" :options="['Name ', 'name']" />
                  </b-form-group>
                </b-col>
              </b-form-row>
            </template>
          </iq-card>
        </b-col>-->
        <b-col lg="6" offset-lg="3">
          <b-button
            block
            type="submit"
            variant="primary"
            class="mb-3 mr-1"
            data-cy="submit-button"
            :disabled="isLoading || hasErrors"
            :label="isLoading ? 'Loading...' : 'Submit this form'"
            >Save campaign</b-button
          >
        </b-col>
      </b-row>
    </FormulateForm>
  </b-container>
</template>

<style scoped>
.carditem {
  height: 8rem;
  display: flex;
  flex-direction: column-reverse;
  border-radius: 0.5rem;
  overflow: hidden;
  cursor: pointer;
  margin-bottom: 3rem;
  position: relative;
  background: url("../../assets/images/newsletter-placeholder.png");
  background-size: cover;
}
.carditem__selected {
  border: 3px var(--iq-primary-light) solid;
}
.carditem__dimmer {
  opacity: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  position: absolute;
  transition: 0.2s;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 1rem;
}
.carditem__dimmer:hover {
  opacity: 1;
}
.carditem__title {
  opacity: 0.85;
  text-align: center;
  width: 100%;
  padding: 0.5rem;
  background: linear-gradient(
    to right,
    var(--iq-primary) 0%,
    var(--iq-primary-light) 100%
  );
}
.carditem__title .h6 {
  color: white;
  font-size: 0.75rem;
  margin-bottom: 0;
  opacity: 1;
}
.btn:disabled {
  opacity: 0.25 !important;
  filter: grayscale(1) !important;
}
.open-detail-label {
  text-align: right;
}
</style>

<script>
import { core } from "../../config/pluginInit";
import { getAccountSync } from "../../Utils/account";
import isEmailOfDomain from "../../Utils/isEmailOfDomain";
import secondLevelDomain from "../../Utils/secondLevelDomain";
import gql from "graphql-tag";
const CREATE_CAMPAIGN = gql`
  mutation createCampaign(
    $name: String!
    $fromName: String
    $fromEmail: String!
    $domain: String!
    $subject: String!
    # $previewText: String
    $listId: uuid!
    $templateId: uuid!
    $targetDealValue: float8
    $productGroups: campaign_product_group_arr_rel_insert_input
    $externalLink: String
  ) {
    insert_campaigns_one(
      object: {
        name: $name
        from_name: $fromName
        from_email: $fromEmail
        subject: $subject
        domain: $domain
        # preview_text: $previewText
        list_id: $listId
        template_id: $templateId
        target_deal_value: $targetDealValue
        campaign_product_groups: $productGroups
        external_link: $externalLink
      }
    ) {
      id
      name
      created_at
      updated_at
    }
  }
`;
const LIST_LISTS = gql`
  query getLists {
    lists {
      id
      name
      created_at
      lists_contacts_aggregate {
        aggregate {
          count
        }
      }
    }
  }
`;
const LIST_TEMPLATES = gql`
  query listTemplates {
    templates(
      order_by: {
        name: asc
      }
    ) {
      id
      name
    }
  }
`;
const LIST_PRODUCT_GROUPS = gql`
  query listProductGroups {
    product_groups {
      id
      name
    }
  }
`;
export default {
  name: "CampaignsCreate",
  data() {
    return {
      formValues: {
        fromEmail: getAccountSync()?.defaultDomain?.includes("omnicrane.com")
          ? "sender@omnicrane.com"
          : `you@${secondLevelDomain(getAccountSync()?.defaultDomain)}`,
        fromName: "",
        templateId: "",
        domain: getAccountSync().defaultDomain || "",
      },
      lists: [],
      templates: [],
      defaultDomain: getAccountSync().defaultDomain,
      allowedDomains: getAccountSync().allowedDomains,
      externalLink: ""
    };
  },
  apollo: {
    lists: {
      query: LIST_LISTS,
      fetchPolicy: "no-cache",
      update: data => data.lists.map(i => {
        return {
          id: i.id,
          name: `${i.name} (${i?.lists_contacts_aggregate?.aggregate?.count})`
        }
      })
    },
    templates: {
      query: LIST_TEMPLATES,
      fetchPolicy: "no-cache"
    },
    productGroupsOptions: {
      query: LIST_PRODUCT_GROUPS,
      update: data => data.product_groups.sort((a, b) => {
        // Convert property values to strings for case-insensitive sorting
        const propA = String(a['name']).toLowerCase();
        const propB = String(b['name']).toLowerCase();

        if (propA < propB) {
          return -1; // a should come before b
        } else if (propA > propB) {
          return 1; // b should come before a
        } else {
          return 0; // a and b are equal
        }
      })
    },
  },
  methods: {
    validateFromEmail({ value, getFormValues }) {
      const d = getFormValues()?.domain;
      return isEmailOfDomain(value, d);
    },
    handleTemplateClicked(templateId) {
      this.formValues.templateId = templateId;
    },
    async submitHandler() {
      const selectedProductGroups = this.formValues.selectedProductGroupIds.map(id => ({
        product_group_id: id
      }))
      try {
        const saveResponse = await this.$apollo.mutate({
          mutation: CREATE_CAMPAIGN,
          variables: {
            name: this.formValues.name,
            fromName: this.formValues.fromName,
            fromEmail: this.formValues.fromEmail,
            domain: this.formValues.domain,
            subject: this.formValues.subject,
            listId: this.formValues.listId,
            templateId: this.formValues.templateId,
            targetDealValue:
              this.formValues.targetDealValue !== ""
                ? this.formValues.targetDealValue
                : null,
            productGroups:
              selectedProductGroups.length > 0
                ? {
                    data: selectedProductGroups
                  }
                : undefined,
            externalLink: this.formValues.externalLink || undefined
          }
        });
        this.$toast.success(`Campaign created`);
        this.$formulate.reset("createCampaign");
        this.$router.push(
          `/campaigns/${saveResponse.data.insert_campaigns_one.id}/edit`
        );
      } catch (error) {
        this.$toast.error(`Failed to create campaign : ${error.message}`);
      }
    }
  },
  computed: {
    isFromEmailEditable() {
      if (this.formValues.domain.includes("omnicrane.com")) {
        return false;
      }
      return true;
    },
    selectedListNumberOfContacts() {
      if (!this.formValues.listId) {
        return null
      }
      return this.lists.find(i => i.id === this.formValues.listId)?.lists_contacts_aggregate?.aggregate.count;
    }
  },
  watch: {
    formValues: {
      handler(newData, oldData) {
        // detect domain change
        const newDomain = newData?.domain;
        const oldDomain = oldData?.domain;
        if (newDomain === oldDomain) {
          return;
        }
        if (newDomain.includes("omnicrane.com")) {
          this.formValues.fromEmail = "sender@omnicrane.com";
          return;
        }
        this.formValues.fromEmail = "you@" + secondLevelDomain(newDomain);
      }
    },
    deep: true
  },
  mounted() {
    core.index();
  }
};
</script>
